import type { RoundClimb } from '../../types/competition-round';

/**
 * "Blocco 2" before "Blocco 11" — plain string comparison gets the digits
 * backwards, so the block name is compared as a number where it has one.
 */
export function byBlockName(a: RoundClimb, b: RoundClimb): number {
  return (a.display_name || '').localeCompare(b.display_name || '', undefined, {
    numeric: true,
    sensitivity: 'base',
  });
}
